import React from 'react';
import Filters from './Filters';
import { initialValues } from './Filters.formConfig';
import { filterData } from './Filters.helpers';

const FiltersContainer = ({ originalInvoices, setRenderInvoices }) => {
  const handleSubmitFilters = (data) => {
    const filteredData = filterData(data, originalInvoices);
    setRenderInvoices(filteredData);
  };

  const handleReset = (resetForm) => {
    resetForm({ values: initialValues });
    setRenderInvoices(originalInvoices);
  };

  return (
    <Filters
      onResetFormClick={handleReset}
      onSubmitFilters={handleSubmitFilters}
    />
  );
};

export default React.memo(FiltersContainer);
